import { createBrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';
import { 
  ConversationLayout, 
  ConversationPage, 
  NewConversationPage,
  HomePage, 
  DoctorConversations 
} from './routeConfig';
import ProtectedRoute from '@/components/ProtectedRoute';
import { EUserRole } from '@/constants';

const router = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <ProtectedRoute allowedRoles={[EUserRole.USER]}>
              <HomePage /> {/* Regular home page - User only */}
            </ProtectedRoute>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/conversation',
    element: (
      <Suspense fallback={null}>
        <ProtectedRoute allowedRoles={[EUserRole.USER]}>
          <ConversationLayout /> {/* Shared context/socket for all conversation routes */}
        </ProtectedRoute>
      </Suspense>
    ),
    children: [
      {
        index: true,
        // /conversation - Welcome prompt only
        element: <NewConversationPage />,
      },
      {
        path: ':id',
        // /conversation/:id - Chat view
        element: <ConversationPage />,
      },
    ],
  },
  {
    path: '/doctor-conversations',
    element: (
      <Suspense fallback={null}>
        <ProtectedRoute allowedRoles={[EUserRole.DOCTOR]} redirectPath="/">
          <DoctorConversations /> {/* Doctor conversations - Doctor only */}
        </ProtectedRoute>
      </Suspense>
    ),
  },
]);

export { router };
